var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('td',[_vm._v(_vm._s(_vm.venta.fecha_de_venta))]),_c('td',[_vm._v("$"+_vm._s(_vm.dotsCadaTres(parseFloat(_vm.venta.precio_total).toFixed(2).replace(/\.00$/, ''))))]),_c('td',[_vm._v(_vm._s(_vm.venta.persona.nombre)+" "+_vm._s(_vm.venta.persona.apellido))]),_c('td',[_vm._v(_vm._s(_vm.venta.estado.nombre))])])
}
var staticRenderFns = []

export { render, staticRenderFns }